import { z } from 'zod';
import { DeviceName, DeviceType, Id, IsoDateTime, PlatformInfo } from './common.js';

export const LocationSource = z.enum(['gps', 'network', 'wifi', 'ip', 'fused', 'other']);
export type LocationSource = z.infer<typeof LocationSource>;

/** A stored location fix, as the dashboard sees it. */
export const Location = z.object({
  id: Id,
  lat: z.number(),
  lon: z.number(),
  accuracyM: z.number(),
  altitude: z.number().nullable(),
  speed: z.number().nullable(),
  heading: z.number().nullable(),
  source: LocationSource,
  batteryPct: z.number().int().nullable(),
  isCharging: z.boolean().nullable(),
  recordedAt: IsoDateTime,
  receivedAt: IsoDateTime,
});
export type Location = z.infer<typeof Location>;

export const Device = z.object({
  id: Id,
  name: z.string(),
  type: DeviceType,
  platformInfo: PlatformInfo,
  capabilities: z.array(z.string()),
  agentVersion: z.string().nullable(),
  createdAt: IsoDateTime,
  lastSeenAt: IsoDateTime.nullable(),
  isLost: z.boolean(),
  lostMessage: z.string().nullable(),
  lostContact: z.string().nullable(),
  revoked: z.boolean(),
  sharingPaused: z.boolean(),
  batteryPct: z.number().int().nullable(),
  isCharging: z.boolean().nullable(),
  lastLocation: Location.nullable(),
});
export type Device = z.infer<typeof Device>;

export const DeviceListResponse = z.object({ devices: z.array(Device) });
export type DeviceListResponse = z.infer<typeof DeviceListResponse>;

export const DeviceIdParams = z.object({ id: Id });

export const RenameDeviceRequest = z.object({ name: DeviceName });
export type RenameDeviceRequest = z.input<typeof RenameDeviceRequest>;
